export const CREATE_DOCUMENT_ACTION = "documents/create-document";
export const GET_ALL_DOCUMENTS_ACTION = "documents/get-all-documents";
export const GET_DOCUMENT_BY_ID_ACTION = "documents/get-document-by-id";
export const PROCESS_DOCUMENT_ACTION = "documents/process-document";
export const CREATE_EXTRACTION_REVIEWS_ACTION =
  "documents/create-extraction-reviews";
export const GET_EXTRACTION_REVIEWS_ACTION = "documents/get-extraction-reviews";
export const CALL_EXTRACTION_REVIEWS_AI_ACTION =
  "documents/call-extraction-reviews-ai";
export const GET_EXTRACTION_REVIEW_BY_ID_ACTION =
  "documents/get-extraction-review-by-id";
export const DELETE_EXTRACTION_REVIEW_ACTION =
  "documents/delete-extraction-review";
export const RETRY_DOCUMENT_ACTION = "documents/retry-document";
